import { NUMS_REGEX } from "./form/constants";

export const getPaymentMethods = (paymentMethods) => {
  return Object.keys(paymentMethods)
    .filter((elem) => paymentMethods[elem])
    .join(", ");
};

export const getFormattedNumberPoints = (pts) => {
  return Number(pts.match(NUMS_REGEX).join(""));
};

export const getEventName = ({ pageName = "", targetLocation = "", target = "", action = "" }) => {
  const eventPageName = pageName ? `${pageName.toLowerCase()}_` : "";
  const eventTargetLocation = targetLocation ? `${targetLocation.toLowerCase()}_` : "";
  const eventTarget = target ? `${target.toLowerCase()}_` : "";
  const eventAction = action.toLowerCase();
  return `${eventPageName}${eventTargetLocation}${eventTarget}${eventAction}`;
};
